var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLocked16Px(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#f28705;stroke-linecap:round;stroke-linejoin:round;stroke-width:0.75px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.16 1.535)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7,
    height: 4.923,
    rx: 1,
    transform: "translate(4.34 5.543)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M7,5.077V3.709A1.818,1.818,0,0,1,8.909,2a1.818,1.818,0,0,1,1.909,1.709V5.077",
    transform: "translate(-1.069 0.466)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 16,
    height: 16
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocked16Px);
export default __webpack_public_path__ + "static/media/Icon_Locked_16px.e444d38493cae6315f3dba396a194e93.svg";
export { ForwardRef as ReactComponent };